import { render, staticRenderFns } from "./PublicationStats.vue?vue&type=template&id=0e55e760"
import script from "./PublicationStats.vue?vue&type=script&lang=js"
export * from "./PublicationStats.vue?vue&type=script&lang=js"
import style0 from "./PublicationStats.vue?vue&type=style&index=0&id=0e55e760&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports